import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface DetailedViewOption {
  id: boolean | null;
  name: string;
}

interface DetailedViewFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const detailedViewOptions: DetailedViewOption[] = [
  { id: null, name: 'No' },
  { id: true, name: 'Yes' },
];

export const DetailedViewFilter: React.FC<DetailedViewFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedOption = detailedViewOptions.find(
    (o) => o.id === (String(value) === 'true' ? true : null)
  );

  if (valueOnly) {
    return <>{selectedOption?.name || ''}</>;
  }

  return (
    <Autocomplete
      options={detailedViewOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id?.toString() || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select View Type" />
      )}
    />
  );
};
